import { h } from 'preact';
import { joinClasses } from 'utils/utils';
import * as BaseComp from 'components/bolt/header/header.js';
import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	render(props) {
		const base = super.render(props);
		if (props?.activePage !== 'aspectRatioTrailer') {
			return base;
		}

		const aspectRatioTrailerScrolled = props?.headerData?.aspectRatioTrailerScrolled;
		const aspectRatioTrailerFullscreen = props?.headerData?.aspectRatioTrailerFullscreen;
		base.attributes.class = joinClasses(
			base.attributes.class,
			aspectRatioTrailerScrolled && s.aspectRatioTrailerScrolled,
			aspectRatioTrailerFullscreen && s.aspectRatioTrailerFullscreen
		);
		return base;
	}

}
